export const filters = [
	{
		name: "green_roof",
		description: "Roofs with a vegetated surface the provide a degree of retention attenuation and treatment of rainwater and promote evapotranspiration.",
    visible: false,
	},
	{
		name: "infiltration",
		description: "Systems that are designed specifically to promote infilitration of surface water runoff into the ground. This includes soakaways, infiltration trenches, infilitration blankets and infiltration basins.",
    visible: false,
	},
	{
		name: "propietary_treatment",
		description: "Surface and subsurface manufactured products designed to provide treatment of water through the removal of contaminants.",
    visible: false,
	},
	{
		name: "filter_strips",
		description: "Vegetated areas of gently sloping ground designed to drain runoff evenly from impermeable areas, filtering out silt and other particulates.",
    visible: false,
	},
	{
		name: "filter_drains",
		description: "Linear drains consisting of a trench filled with a permeable aggregate material, often with a perforated pipe in the base of the trench to assist drainage.",
    visible: false,
	},
	{
		name: "swales",
		description: "Shallow vegetated channels designed principally to convey and treat runoff.",
    visible: false,
	},
	{
		name: "bioretention",
		description: "E.g. rain gardens. Shallow planted depressions that allow runoff to pond temporarily on the surface, before filtering through vegetation and underlying souls for collection or infiltration.",
    visible: false,
	},
	{
		name: "trees",
		description: "Tree pits and planters can be designed to collect and attenuate runoff by providing additional storage within the underlying structure.",
    visible: false,
	},
	{
		name: "attenuation_storage",
		description: "Structures (e.g. tanks) that create a below ground void space for the temporary storage of surface water before infiltration, controlled release or use.",
    visible: false,
	},
	{
		name: "detention_basin",
		description: "Landscaped depressions that are normally dry, except during and following rainfall events, designed to attenuate runoff and, where vegetated, provide treatment.",
    visible: false,
	},
	{
		name: "ponds_wetlands",
		description: "Depressions designed to temporarily store surface water above permanently wet pool that permit settlement of suspended solids and biological removal of pollutants.",
    visible: false,
	},
  {
    name: "downpipe_disconnection",
    description: "Including SuDS rain planters that collect water directly from downpipes.",
    visible: false,
  }
];

export const filterVisibilities = () => {
  return filters.reduce((acc, f) => {
    acc[f.name] = { visible: f.visible }
    return acc
  }, {})
}